import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesComponent } from './pages.component';
import { RouterModule, Routes } from '@angular/router';
import { PipesModule } from '@app/core';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/core/shared/shared.module';
// import { NgxCaptchaModule } from 'ngx-captcha';
import { AuthGuard } from '@app/core/guard/auth.guard';
// import { NgCircleProgressModule } from 'ng-circle-progress';
import { SubscriptionComponent } from './subscription/subscription.component';

const routes: Routes = [
  {
    path: 'expert-picks',
    loadChildren: () =>
      import('@views/pages/expert-picks/expert-picks.module').then(
        (m) => m.ExpertPicksModule
      ),
  },
  {
    path: 'place-picks',
    loadChildren: () =>
      import('@views/pages/place-picks/place-picks.module').then(
        (m) => m.PlacePicksModule
      ),
  },
  {
    path: 'free-picks',
    loadChildren: () =>
      import('@views/pages/free-picks/free-picks.module').then(
        (m) => m.FreePicksModule
      ),
  },
  {
    path: 'chat',
    loadChildren: () =>
      import('@views/pages/chat/chat.module').then((m) => m.ChatModule),
  },
  {
    path: 'how-it-works',
    loadChildren: () =>
      import('@views/pages/how-it-works/how-it-works.module').then(
        (m) => m.HowItWorksModule
      ),
  },
  {
    path: 'faq',
    loadChildren: () =>
      import('@views/pages/faq/faq.module').then((m) => m.FaqModule),
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('@views/pages/privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyModule
      ),
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('@views/pages/privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyModule
      ),
  },
  {
    path: 'terms-of-service',
    loadChildren: () =>
      import('@views/pages/terms-of-service/terms-of-service.module').then(
        (m) => m.TermsOfServiceModule
      ),
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('@views/pages/contactus/contactus.module').then(
        (m) => m.ContactusModule
      ),
  },
  {
    path: 'top-bettors',
    loadChildren: () =>
      import('@views/pages/kingpins/kingpins.module').then(
        (m) => m.KingpinsModule
      ),
    data: { loggedin: false, title: 'Top Experts', desc: 'top handicappers' },
  },
  {
    path: 'my-experts',
    loadChildren: () =>
      import('@views/pages/kingpins/kingpins.module').then(
        (m) => m.KingpinsModule
      ),
    canActivate: [AuthGuard],
    data: { loggedin: true, title: 'My Experts', desc: 'my handicappers' },
  },
  {
    path: 'subscription',
    component: SubscriptionComponent,
  },
  {
    path: 'career',
    loadChildren: () =>
      import('@views/pages/career/career.module').then((m) => m.CareerModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('@views/pages/my-profile/my-profile.module').then(
        (m) => m.MyProfileModule
      ),
  },
  {
    path: ':slug/profile',
    loadChildren: () =>
      import('@views/pages/user-profile/user-profile.module').then(
        (m) => m.UserProfileModule
      ),
  },
  {
    path: 'articles/:slug',
    loadChildren: () =>
      import('@views/pages/article-detail/article-detail.module').then(
        (m) => m.ArticleDetailModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('@views/pages/home/home.module').then((m) => m.HomeModule),
  },
  { path: '', redirectTo: '', pathMatch: 'full' }, // redirect to `first-component`
  // { path: '**', redirectTo: '' },
];

@NgModule({
  declarations: [PagesComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    PipesModule,
    SharedModule,
    // FormsModule,
    // ReactiveFormsModule,
    // NgxCaptchaModule,
  ],
})
export class PagesModule { }
